import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, withRouterConfig } from '@angular/router';

import { AuthConfig, ICache, provideAuth0 } from '@auth0/auth0-angular';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { environment } from 'src/environments/environment';

import { routes } from './app.routes';
import { billerudTheme } from './billerud.theme';
import { BkAuthHttpInterceptor } from './interceptors/auth.interceptor';
import { CacheIntercetpor2 } from './interceptors/cache.interceptor2';
import { DebugInterceptor } from './interceptors/debug.interceptor';
import { DemoInterceptor } from './interceptors/demo.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';

export class TokenCache implements ICache {
  private cache: Record<string, any> = {};
  public get(key: string): any {
    return this.cache[key];
  }
  public set(key: string, value: any): void {
    this.cache[key] = value;
  }
  public remove(key: string): void {
    delete this.cache[key];
  }
}

const pathName = window.location.pathname;
const locale =
  pathName === '/' || pathName === '/login' ? 'en' : window.location.pathname.slice(1, 3);
const redirectUri = environment.redirectUri.replace('LOCALE', locale);

const authConfig: AuthConfig = {
  domain: environment.domain,
  clientId: environment.clientId,
  useRefreshTokens: true,
  cache: new TokenCache(),
  authorizationParams: {
    redirect_uri: redirectUri,
    audience: environment.audience,
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      //withPreloading(PreloadAllModules),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptorsFromDi()),

    {
      provide: HTTP_INTERCEPTORS,
      useClass: BkAuthHttpInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: CacheIntercetpor2, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DemoInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DebugInterceptor, multi: true },
    provideAuth0(authConfig),

    providePrimeNG({
      theme: {
        preset: billerudTheme,
        options: {
          darkModeSelector: '.dark',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, primeng',
          },
        },
      },
    }),
  ],
};
